import script from "./cotizacionOpciones.vue?vue&type=script&setup=true&lang=ts"
export * from "./cotizacionOpciones.vue?vue&type=script&setup=true&lang=ts"

import "./cotizacionOpciones.vue?vue&type=style&index=0&id=1b088340&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b088340"]])

export default __exports__